export const SHOP_ID = 'yamaha-motor-europe-staging';
export const FASLET_SHOPPING_ID = 'fasletShoppingId';
export const FASLET_ORDER_TRACKING_STATE = 'fasletOrderTrackingState';
